// extracted by mini-css-extract-plugin
export default {"adminPropertiesModal":"UploadPropertiesModal_adminPropertiesModal__E37gJ"};